import { render } from "./lyvideo.vue?vue&type=template&id=20d7e371"
import script from "./lyvideo.vue?vue&type=script&lang=js"
export * from "./lyvideo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__